import { Deserializable } from './deserializable.model';
import { Image } from './image.model';
import { JsonProperty } from 'json-typescript-mapper';

export class News implements Deserializable {
  @JsonProperty('id')
  id?: number;
  @JsonProperty('image')
  image?: Image;
  @JsonProperty('title')
  title?: string;
  @JsonProperty('text')
  text?: string;
  @JsonProperty('publishFromDate')
  publishFromDate?: string;
  @JsonProperty('publishUntilDate')
  publishUntilDate?: string;
  @JsonProperty('active')
  active?: boolean;
  @JsonProperty('type')
  type?: 'global' | 'branch' | 'commune' | 'market';
  @JsonProperty('identifier')
  identifier?: string;
  @JsonProperty('createdAt')
  createdAt: string;
  @JsonProperty('createdBy')
  createdBy: number;
  @JsonProperty('createdByDisplayName')
  createdByDisplayName: string;
  @JsonProperty('createdByMerchantNumber')
  createdByMerchantNumber: number;
  @JsonProperty('updatedAt')
  updatedAt: string;
  @JsonProperty('updatedBy')
  updatedBy: number;
  @JsonProperty('updatedByDisplayName')
  updatedByDisplayName: string;
  @JsonProperty('updatedByMerchantNumber')
  updatedByMerchantNumber: number;

  @JsonProperty('publishFromDateIso')
  publishFromDateIso?: string;
  @JsonProperty('publishUntilDateIso')
  publishUntilDateIso?: string;
  @JsonProperty('createdAtIso')
  createdAtIso: string;
  @JsonProperty('updatedAtIso')
  updatedAtIso: string;

  constructor(input?: any) {
    this.id = void 0;
    this.image = void 0;
    this.title = void 0;
    this.text = void 0;
    this.publishFromDate = void 0;
    this.publishUntilDate = void 0;
    this.active = void 0;
    this.type = void 0;
    this.identifier = void 0;
    this.createdAt = void 0;
    this.createdBy = void 0;
    this.createdByDisplayName = void 0;
    this.createdByMerchantNumber = void 0;
    this.updatedAt = void 0;
    this.updatedBy = void 0;
    this.updatedByDisplayName = void 0;
    this.updatedByMerchantNumber = void 0;
    this.publishFromDateIso = void 0;
    this.publishUntilDateIso = void 0;
    this.createdAtIso = void 0;
    this.updatedAtIso = void 0;

    if (input) {
      Object.assign(this, input);
    }
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    this.publishFromDateIso = new Date(input.publishFromDate).toISOString();
    this.publishUntilDateIso = new Date(input.publishUntilDate).toISOString();
    this.createdAtIso = new Date(input.createdAt).toISOString();
    this.updatedAtIso = new Date(input.updatedAt).toISOString();
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/news.model.ts